<template>
  <div class="container">
    <div id="header" class="flex flex-row-left  margin-top-20 ">
      <div class="flex-item-center">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="物流单号">
            <el-input style="width:200px" v-model="formInline.trackNumber" placeholder="物流单号" clearable />
          </el-form-item>
          <el-form-item label="产品相关">
            <el-input style="width:200px" v-model="formInline.mater" placeholder="产品SKU,名称" clearable />
          </el-form-item>
          <el-form-item label="物流单号匹配状态">
            <el-select
                v-model="formInline.trackStatus"
                filterable
                clearable
                @clear="formInline.trackStatus=''"
                :placeholder="请选择入库仓库"
                remote-show-suffix
                class="mobile-select"
                @change="handleChange"
            >
              <el-option
                  v-for="item in trackStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="入库仓库">
            <el-select
                v-model="formInline.warehouseId"
                filterable
                clearable
                @clear="formInline.warehouseId=''"
                :placeholder="请选择入库仓库"
                remote-show-suffix
                class="mobile-select"
                @change="handleChange"
            >
              <el-option
                  v-for="item in stockList"
                  :key="item.warehousefCode"
                  :label="item.warehouseName"
                  :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="入库状态">
            <el-select
                @clear="formInline.status=''"
                v-model="formInline.status"
                clearable
                multiple
                collapse-tags
                collapse-tags-tooltip
                placeholder="请选择入库状态"
                remote-show-suffix
                style="width: 200px"
            >
              <el-option
                  v-for="item in resiveList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="临时入库时间">
            <el-date-picker
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="formInline.startMonth"
                type="date"
                placeholder="请选择临时入库时间"
                clearable
                @clear="formInline.startMonth=''"
            />
            -
            <el-date-picker
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="formInline.endMonth"
                type="date"
                placeholder="请选择临时入库时间"
                clearable
                @clear="formInline.endMonth=''"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button type="success" style="margin-left: 12px;" @click="handleExport">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="margin-20-0">
      <div>
        <el-table
            :max-height="dynamicHeight"
            :data="tableData"
            :preserve-expanded-content="true"
            :stripe="true" :border="true"
            :highlight-current-row="true"
            size="default"
            @sort-change="handleSortChange"
            @selection-change="handleSelectionChange"
        >
          <el-table-column
              label="操作号"
              min-width="80"
              prop="uniPlatformId"
          ></el-table-column>
          <el-table-column
              label="马帮入库批次号"
              min-width="80"
              prop="maOrder"
          ></el-table-column>
          <el-table-column
              label="入库方式"
              width="120"
              prop="inType"
          >
            <template #default="scope">
              <span v-if="(scope.row.status==2 && scope.row.maOrder)">{{scope.row.inType}}</span>
              <span v-if="(scope.row.status==1 && !scope.row.maOrder)">匹配入库</span>
              <span v-if="(scope.row.status==3 && scope.row.maOrder)">维修手工入库</span>
            </template>
          </el-table-column>
          <el-table-column
              label="产品SKU"
              min-width="100"
              prop="sku"
          ></el-table-column>
          <el-table-column
              label="产品名称"
              min-width="100"
              prop="materName"
          ></el-table-column>
          <el-table-column
              class="center"
              label="产品图片"
              width="175"
              prop="pictureUrl"
          >
            <template #default="scope">
              <MyImage :picture-url="scope.row.pictureUrl" :picture-url-list="[scope.row.pictureUrl] "></MyImage>
            </template>
          </el-table-column>
          <el-table-column
              label="入库仓库"
              min-width="100"
              prop="warehouseName"
          >
          </el-table-column>
          <el-table-column
              label="入库数量"
              min-width="50"
              prop="quantity"
          >
          </el-table-column>
          <el-table-column
              label="签收入库时间"
              min-width="80"
              prop="CreateTime"
          ></el-table-column>
          <el-table-column
              label="条码信息"
              min-width="100"
              prop="trackNumber"
          >
            <template #default="scope">
              <span :key="index" v-for="(item,index) in scope.row.trackNumber" >{{item}}</span>
            </template>
          </el-table-column>
          <el-table-column
              label="退货物流"
              min-width="100"
              prop="rearTrackNumber"
          >
          </el-table-column>
          <el-table-column
              label="签收人"
              min-width="70"
              prop="operationPerson"
          ></el-table-column>
          <el-table-column
              class="center"
              label="图片"
              width="175"
              prop="image"
          >
            <template #default="scope">
              <MyImage v-if="scope.row.image.length>0" :picture-url="scope.row.image[0]" :picture-url-list="scope.row.image"></MyImage>
              <span v-else >暂无图片</span>
            </template>
          </el-table-column>
          <el-table-column
              label="退回备注"
              min-width="80"
              prop="remark"
          ></el-table-column>
          <el-table-column
              label="入库状态"
              width="150"
              prop="status"
          >
            <template #default="scope">
              <div>
                <span v-if="scope.row.status==0" >操作状态:未入库</span>
                <span v-if="scope.row.status==1" >操作状态:匹配入库</span>
                <span v-if="scope.row.status==2">操作状态:手动入库</span>
                <span v-if="scope.row.status==3">操作状态:维修手动入库</span>
                <span v-if="scope.row.status==4">操作状态:确认异常</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="重试次数"
              min-width="80"
              prop="tryCount"
          ></el-table-column>
          <el-table-column
              label="失败原因"
              min-width="100"
              prop="reason"
          ></el-table-column>
          <el-table-column
              label="核对备注"
              min-width="100"
              prop="check_remarks"
          >
            <template #default="scope">
              <div
                  v-if="scope.row.editRemarks"
                  class="edit-cell"
                  @click.stop
              >
                <el-input
                    v-model="scope.row.check_remarks"
                    size="small"
                    ref="remarkInput"
                    @blur="handleRemarkBlur(scope.row)"
                    @keyup.enter="handleRemarkBlur(scope.row)"
                    auto-complete="off"
                  />
              </div>
              <span v-else @click="handleRemarkClick(scope.row)" class="remark-cell" :class="{ 'empty-remark': !scope.row.check_remarks }">
                <template v-if="scope.row.check_remarks">{{ scope.row.check_remarks }}</template>
                <template v-else><span class="placeholder-text">添加备注</span></template>
              </span>
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
              min-width="120"
              prop="addServices"
              fixed="right"
          >
            <template #default="scope">
              <el-button :disabled="scope.row.status==1 || scope.row.isUpload==1" link type="primary" size="small" @click="handleClick(scope.row)">手工入库</el-button>
              <el-button link type="primary" size="small" @click="handle(scope.row)">核实物流信息</el-button>
              <el-button link type="primary" size="small" @click="handleSure(scope.row)">核实已入库</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination v-model:current-page="currentPage"  :page-size="pageSize" :total="pageTotal" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" background layout="total, sizes, prev, pager, next,"  />
      </div>
    </div>
    <addInStore ref="addInStore" @closeEdit="close"></addInStore>
    <addInStoreTrack ref="addInStoreTrack" @closeEdit="close"></addInStoreTrack>
    <el-dialog
        title="确认操作"
        v-model="confirmDialogVisible"
        width="400px"
    >
      <span>确定售后仓已签收且马帮已入库？</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="confirmDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleConfirm">确认</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import {
  ElForm, ElFormItem, ElButton, ElInput, ElDatePicker, ElTable,

  ElTableColumn, ElPagination, ElSelect, ElOption, ElMessage
} from "element-plus";
import MyImage from "@/components/myImage.vue";
import {getTempInStore, tempInStoreCheckRemarks,updateTempInStoreTrack} from "@/utils/api";
import {baseUrl}  from "../../../src/utils/requset.js";
import DynamicHeightMixin from "../../../public/js/dynamicHeightMixin";
import {getLocalStockList} from "../../../public/js";
import addInStore from "@/components/addInStore.vue";
import addInStoreTrack from "@/components/addInStoreTrack.vue";


export default {
  name: "tempInStore",
  mixins:[DynamicHeightMixin],
  components: {ElForm,ElFormItem,ElButton,ElInput,ElDatePicker,ElTable,MyImage,ElSelect,ElOption,addInStore,addInStoreTrack,
    ElTableColumn,ElPagination},
  data(){
    return{
      formInline:{
        status:[1]
      },
      stockList:[],
      tableData:[],
      trackStatusList:[
          {"label":"未匹配","value":1},
          {"label":"已匹配","value":2},
      ],
      resiveList:[
        {label:"未入库",value:1},
        {label:"匹配入库",value:2},
        {label:"手工入库",value:3},
        {label:"维修手工入库",value:4},
        {label:"异常数据",value:5},
      ],
      currentPage:1,
      pageTotal:0,
      pageSize:20,
      confirmDialogVisible: false,
      currentData: null
    }
  },
  beforeMount() {
    this.getReceipt();
    this.getLocalStockList()
  },
  mounted() {
    this.formInline.status = [1];
  },
  methods:{
      handleRemarkClick(row) {
        console.log('点击了核对备注:', row);
        // 保存原始值，用于后续比较是否有变化
        row.originalCheckRemarks = row.check_remarks;
        // 重置所有行的编辑状态
        this.tableData.forEach(item => {
          // 在Vue 3中，直接赋值即可
          item.editRemarks = false;
        });
        // 设置当前行为编辑状态 - 在Vue 3中直接赋值
        row.editRemarks = true;
        // 确保输入框在DOM更新后获得焦点
        this.$nextTick(() => {
          const input = document.querySelector(`.edit-cell input`);
          if (input) {
            input.focus();
          }
        });
      },
      async handleRemarkBlur(row) {
        // 取消编辑状态
        row.editRemarks = false;
        
        // 检查值是否有变化，如果没有变化则不调用API
        if (row.check_remarks === row.originalCheckRemarks) {
          console.log('备注值未变化，不保存');
          return;
        }
        
        // 调用API保存数据
        try {
          // 直接使用row对象中的tempInStoreId属性（如果存在），否则使用row.id
          await tempInStoreCheckRemarks({
            tempInStoreId: row.tempInStoreId,
            CheckRemarks: row.check_remarks || ''
          });
          console.log('保存成功，tempInStoreId:', row.tempInStoreId || row.id);
        } catch (error) {
          console.error('保存失败:', error);
          this.$message.error('保存失败，请重试');
        }
      },
    getLocalStockList(){
      getLocalStockList().then(res => {
        this.stockList = res.filter(item=>{
          return item.warehouseName.includes("美国售后仓")
        })
      })
    },
    onSubmit(){
      this.PageNumber = 1
      this.getReceipt()
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getReceipt();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getReceipt();
    },
    getReceipt(){
      getTempInStore({...this.formInline,PageSize:this.pageSize,PageNumber:this.currentPage}).then(res=>{
        this.tableData = res.Data
        this.pageTotal = res.Total
      }).catch(res=>{
        console.log(res)
      })
    },
    handleClick(data){
      this.$refs.addInStore.open(data)
    },
    handle(data){
      this.$refs.addInStoreTrack.open(data)
    },
    check(data){
      this.$refs.arehouseAndQuality.open(data)
    },
    close(){
      this.getReceipt()
    },
    // 导出功能，参考 operationLog.vue 的导出逻辑
    handleExport() {
      // 将表单参数编码后附加到URL上
      let pramas = Object.entries(this.formInline)
          .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
          .join('&');
      // 假设导出接口为 export_tempInStore
      let url = baseUrl + 'after/export_tempInStore?'+ pramas;
      
      // 打开新窗口导出
      window.open(url);
    },
    handleSure(data){
      this.currentData = data;
      this.confirmDialogVisible = true;
    },
    handleConfirm() {
      updateTempInStoreTrack({
        sku:this.currentData.sku,
        tempInStoreId:this.currentData.tempInStoreId,
        rearTrackNumber:"",
        status:4
      }).then(res=>{
        console.log(res)
        this.confirmDialogVisible = false;
        ElMessage.success("操作成功")
        this.getReceipt()
      }).catch(err=>{
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>
.container{
  width: 92%;
  margin:0 auto;
}
::v-deep .container {
  .el-form-item{
    margin-bottom:0!important;
  }
}
::v-deep .el-table .el-table__cell{
  box-sizing: border-box;
  min-width: 0;
  padding: 8px 0;
  position: relative;
  text-align: left;
  text-overflow: ellipsis;
  vertical-align: middle;
  z-index: unset !important;
}
.edit-cell {
  padding: 0 8px;
}
.edit-cell .el-input {
  margin: 0;
}
.edit-cell .el-input__wrapper {
  padding: 0 8px;
  box-shadow: none;
  border-color: #dcdfe6;
}
.edit-cell .el-input__wrapper:focus-within {
  box-shadow: 0 0 0 1px #409eff inset;
  border-color: #409eff;
}
.remark-cell {
  display: inline-block;
  padding: 2px 8px;
  cursor: pointer;
  min-height: 20px;
  min-width: 20px;
}
.remark-cell:hover {
  background-color: #f5f7fa;
  border-radius: 3px;
}
/* 无值备注的样式 */
.empty-remark {
  border: 1px dashed #dcdfe6;
  background-color: #f8f9fa;
  padding: 2px 8px;
  border-radius: 3px;
  color: inherit;
}
.empty-remark:hover {
  border-color: #409eff;
  background-color: #ecf5ff;
}

/* 占位符文本样式 */
.placeholder-text {
  color: #909399;
}
.empty-remark:hover .placeholder-text {
  color: #409eff;
}
::v-deep .el-button+.el-button {
  margin-left: 0px;
}


</style>